import { createStoreUnit } from 'src/redux/helpers';
import { ALERTS_STORE } from '../constants';
import alertsList from './AlertsSlice';

const alertsListSlice = createStoreUnit({
  name: ALERTS_STORE,
  slices: {
    alertsList,
  },
});

export default alertsListSlice;
